import React, { Component } from 'react'
import Input from './../input'
import { Form } from 'formsy-react'
import qs from 'qs'
import { PROTOCOL } from './../../lib/helper'
import _ from 'underscore'
import PropTypes from 'prop-types'
import AdvancedOptionsForm from './../forms/advancedoptionsform'

const FORMTYPE = { FTP: 1, HTTP: 2 }

class PressableForm extends Component{
	constructor(props){
		super(props)
		this.state = {currentForm: this.getCurrentFormType()}
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
	}

	getAppliedFilters() {
		const { history } = this.props
		const { location } = history
		return qs.parse(location.search, { ignoreQueryPrefix: true })
	}

	getCurrentFormType() {
		const { errors, migrate } = this.props
		const queryParams = this.getAppliedFilters()
		let currentForm = FORMTYPE.FTP

		if (queryParams.http_migration) {
			currentForm = FORMTYPE.HTTP
		} else if (errors.length) {
			currentForm = migrate.get('protocol') === PROTOCOL.HTTP ? FORMTYPE.HTTP : FORMTYPE.FTP
		}
		return currentForm
	}

	getCurrentForm() {
		const { currentForm } = this.state;
		switch (currentForm) {
			case FORMTYPE.HTTP:
				return this.httpForm();
			default:
				return this.ftpForm();
		}
	}

	fetchValue(key) {
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	getClassName(key) {
		const { errors } = this.props
		let classname = "col-md-12 col-xs-12"
		if (_.contains(errors, key)){
			classname += " error-field"
		}
		return classname
	}

	ftpForm() {
		const { error } = this.props
		return <div className="pb-1">
			{ error && <div className="pb-2 mb-2 font12">{error}</div> }
			<div className="row">
				<div className={this.getClassName('newurl')}>
					<i className="mdi mdi-web"></i>
					<Input
						type="text"
						name="newurl"
						title="Destination Site URL"
						placeholder="Eg. www.google.com"
						classname=""
						value={this.fetchValue('newurl')}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('address')}>
					<i className="mdi mdi-server"></i>
					<Input
						type="text"
						name="address"
						title="SFTP Address"
						placeholder="sftp.pressable.com"
						classname=""
						value="sftp.pressable.com"
						disabled={true}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('username')}>
					<i className="mdi mdi-account"></i>
					<Input
						type="text"
						name="username"
						title="SFTP User"
						placeholder="Enter SFTP username here"
						classname=""
						value={this.fetchValue('username')}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('passwd')}>
					<i className="mdi mdi-lock"></i>
					<Input
						type="password"
						name="passwd"
						title="SFTP Password"
						placeholder="Enter SFTP password here"
						classname=""
						value={this.fetchValue('passwd')}
					/>
				</div>
			</div>
			<div className="row hide-field">
				<Input
					type="hidden"
					name="type"
					value="sftp"
					title=""
					placeholder=""
					classname=""
				/>
			</div>
		</div>
	}

	httpForm() {
		const { error } = this.props
		return (
			<div>
				{error && <div className="pb-2 mb-2 font12">{error}</div>}
				<div className="row">
					<div className={this.getClassName('bv_migration_key')}>
						<i className="mdi mdi-key"></i>
						<Input
							type="text"
							name="bv_migration_key"
							title="BV Migration Key"
							placeholder="Eg. aHR0cDovLzEyNy4wLjAuMS9zaXtTGZzQ="
							classname=""
							value={this.fetchValue('bv_migration_key')}
						/>
					</div>
				</div>
				<div className="row hide-field">
					<Input
						type="hidden"
						title=""
						name="protocol"
						placeholder=""
						classname=""
						value={PROTOCOL.HTTP}
					/>
				</div>
			</div>
		);
	}

	render() {
		const { migrate, handleSubmit, loading, errors, fields, params, directoryList, getDirectoryList, changeSelection,
			tablesList, getTablesList, changeTableSelection, directoriesSelectAllDisabled, allDirectoriesSelected, selectAllDirectories,
			tablesSelectAllDisabled, allTablesSelected, selectAllTables } = this.props
		return <div className="bv-body dh">
			{loading}
			<div className="col-xs-7 col-md-4 center-dom text-center container bv-form" >
				<Form onSubmit={handleSubmit} className="bv-form-label-left-align mg-form px-15">
					<div>
						{this.getCurrentForm()}
						<div className="row hide-field">
							<Input
								type="hidden"
								name="migrate"
								value="pressable"
								title=""
								placeholder=""
								classname=""
							/>
						</div>
						<AdvancedOptionsForm
							migrate={migrate}
							errors={errors}
							fields={fields}
							params={params}
							directoryList={directoryList}
							tablesList={tablesList}
							getDirectoryList={getDirectoryList}
							getTablesList={getTablesList}
							changeSelection={changeSelection}
							changeTableSelection={changeTableSelection}
							directoriesSelectAllDisabled={directoriesSelectAllDisabled}
							allDirectoriesSelected={allDirectoriesSelected}
							selectAllDirectories={selectAllDirectories}
							tablesSelectAllDisabled={tablesSelectAllDisabled}
							allTablesSelected={allTablesSelected}
							selectAllTables={selectAllTables}
						/>
						<input type="submit" value="Migrate" className="bv-primary-button"/>
					</div>
				</Form>
			</div>
		</div>
	}
}

PressableForm.propTypes = {
	handleSubmit: PropTypes.func,
	fields: PropTypes.object,
	errors: PropTypes.array,
	error: PropTypes.object,
	directoryList: PropTypes.array,
	changeSelection: PropTypes.func,
	getDirectoryList: PropTypes.func,
	loading: PropTypes.bool,
	migrate: PropTypes.object,
	params: PropTypes.object,
	tablesList: PropTypes.array,
	getTablesList: PropTypes.func,
	changeTableSelection: PropTypes.func,
	directoriesSelectAllDisabled: PropTypes.boolean,
	allDirectoriesSelected: PropTypes.boolean,
	selectAllDirectories: PropTypes.func,
	tablesSelectAllDisabled: PropTypes.boolean,
	allTablesSelected: PropTypes.boolean,
	selectAllTables: PropTypes.func
}

export default PressableForm
